module.exports = __webpack_public_path__ + "img/index-section5-banner.5c43e99c.png";